import {
  TOGGLE_DYNAMIC_MESSAGE_FILTER,
  TOGGLE_ALWAYS_OPEN_NEW_MESSAGES,
  TOGGLE_PRESS_ENTER_TO_SEND_MESSAGE,
  TOGGLE_RECEIVE_EMAIL_NOTIFICATIONS,
  SET_CONFIGURATION_ID,
} from "../constants/actionTypes";

export function toggleDynamicMessageFilter() {
  return {
    type: TOGGLE_DYNAMIC_MESSAGE_FILTER,
  };
}

export function toggleAlwaysOpenNewMessages() {
  return {
    type: TOGGLE_ALWAYS_OPEN_NEW_MESSAGES,
  };
}

export function togglePressEnterToSendMessage() {
  return {
    type: TOGGLE_PRESS_ENTER_TO_SEND_MESSAGE,
  };
}

export function toggleReceiveEmailNotifications() {
  return {
    type: TOGGLE_RECEIVE_EMAIL_NOTIFICATIONS,
  };
}

export function setConfigurationId(id) {
  return {
    type: SET_CONFIGURATION_ID,
    id: id,
  };
}
